<template>
    <div class="tariffication_packet_item_info">

        <div v-if="loading" style="height: 100%">
            <div class="spinner">
                <scale-loader />
            </div>
        </div>
        <div v-else class="content">
            <div class="header">
                <h4 class="title">
                    {{ 'Информация по тарифицируемому пакету (ID = ' + tariffication_packet_item.id + ')' }}
                </h4>
            </div>

            <div class="header">
                <h5 class="title">
                    {{ 'Информация по операторскому пакету' }}
                </h5>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.mno_packet_name" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.mno_packet_name')" :readonly="true" />
                </div>
                <div class="col-md-6">
                    <fg-input v-model="tariffication_packet_item.mno_packet_key" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.mno_packet_key')" :readonly="true" />
                </div>
            </div>

            <div class="header">
                <h5 class="title">
                    {{ 'Информация по тарифицируемому пакету  и устройству' }}
                </h5>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.date" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.date')" :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.tariff_name" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.tariff_name')" :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.tariff_packet_name" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.tariff_packet_name')"
                        :readonly="true" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="device_name" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.device_name')" :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.imsi" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.imsi')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.iccid" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.iccid')"
                        :readonly="true" />
                </div>
            </div>

            <div class="header">
                <h5 class="title">
                    {{ 'Информация по остаткам трафика' }}
                </h5>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.packet_traffic_available" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.packet_traffic_available')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.operator_traffic_available" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.operator_traffic_available')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="tariffication_packet_item.traffic_used" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.traffic_used')" :readonly="true" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-3">
                    <fg-input v-model="status_text" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.status')" :readonly="true" />
                </div>
                <div class="col-md-3">
                    <fg-input v-model="date_start" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.ts_create')" :readonly="true" />
                </div>
                <div class="col-md-3">
                    <fg-input v-model="date_update" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.ts_update')" :readonly="true" />
                </div>
                <div class="col-md-3" v-if="tariffication_packet_item.ts_end > 0">
                    <fg-input v-model="date_end" type="text"
                        :label="translate('traffic_packet_list.tariffication_packet_item.ts_end')" :readonly="true" />
                </div>
            </div>

            <div class="modal_clients__footer">
                <div class="text-center">
                    <span v-if="false" class="btn btn-success btn-fill btn-wd marginButton" @click.prevent="save_change">
                        {{ translate('close') }}
                    </span>

                    <span class="btn btn-danger btn-fill btn-wd marginButton" @click.prevent="close">
                        {{ translate('close_modal') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "TarifficationPacketItem",
    props: ['tariffication_packet_item_id'],
    data() {
        return {
            options: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            },
            loading: true,
            tariffication_packet_item: null,
            tariff_active: true
        }
    },
    created() {
        this.init()
    },
    computed: {
        //TODO вынести в какой то компонент для работы с датами видимо
        date_start() {
            return this.tariffication_packet_item.ts_create > 0 ? this.get_date(this.tariffication_packet_item.ts_create, this.options) : ''
        },
        date_update() {
            return this.tariffication_packet_item.ts_update > 0 ? this.get_date(this.tariffication_packet_item.ts_update, this.options) : ''
        },
        date_end() {
            return this.tariffication_packet_item.ts_end > 0 ? this.get_date(this.tariffication_packet_item.ts_end, this.options) : ''
        },
        device_name() {
            return this.tariffication_packet_item.device_fid ? (this.tariffication_packet_item.device_fid + ' (' + this.tariffication_packet_item.device_name) + ')' : ''
        },
        status_text() {
            return this.tariffication_packet_item.status > 0 ? 'Активен' : 'Не активен';
        },
    },

    methods: {
        close() {
            this.$emit('close')
        },
        init() {
            this.$http.v1.getTarifficationPacketItem(this.tariffication_packet_item_id, (response) => {
                this.tariffication_packet_item = response.data
                this.loading = false
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.tariffication_packet_item_info {
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header {
        text-align: center;

        .title {
            margin-top: 15px;
        }
    }
}

.content {
    .row {
        margin: 0;
        text-align: left;

        .area {
            margin-bottom: 10px;
        }
    }

    .filter.checkbox {
        min-width: auto;
        margin-top: 20px;
    }
}
</style>
